import axios from "axios";
import {
  Transaction,
  CorrectionRawResponse,
  CreateReceiptFormValues,
} from "fe-shared-transactions/src/types";
import { TransactionRecordsListItem } from "fe-shared/src/types/common/records";
import transactionPhotosConverter from "fe-shared-transactions/src/helpers/transactionPhotosConverter";

export interface GetLinkedTransactions {
  transactionNumber: string;
  isTargetTransactionNext?: boolean;
}

export const getTransaction = (apiBaseUrl?: string) => (
  queryKey: string,
  transactionNumber: string
): Promise<Transaction> =>
  axios
    .get("transactions", {
      params: { transactionNumber },
    })
    .then((res) =>
      transactionPhotosConverter(res.data.transaction, apiBaseUrl)
    );

export const getCorrections = (
  queryKey: string,
  transactionNumber: string
): Promise<CorrectionRawResponse> =>
  axios
    .get("corrections", {
      params: { transactionNumber },
    })
    .then((res) => res.data);

export const createReceipt = (
  transactionId: number,
  values: CreateReceiptFormValues
): Promise<void> =>
  axios
    .post("transactions/createReceipt", {
      transactionId,
      scaleTicketNumber: values.scaleTicketNumber,
      grossWeight: values.grossWeight,
      tareWeight: values.tareWeight,
      comment: values.comment || null,
      scaleTicketFiles: values.scaleTicketFiles.map((f) => f.path),
      tirePhotoFiles: values.tirePhotoFiles.map((f) => f.path),
      attachments: values.attachments.map((f) => f.path),
      targetWarehouseId: values.targetWarehouseId ?? null,
      trailerNumber: values.trailerNumber ?? null,
      actualTransactionDate: values.actualTransactionDate ?? null,
      useActualTransactionDateAsScaleTicketDate:
        values.useActualTransactionDateAsScaleTicketDate,
    })
    .then((res) => res.data);

export const getLinkedTransactions = (
  params: GetLinkedTransactions
): Promise<TransactionRecordsListItem[]> =>
  axios
    .get("linkedTransactions/getLinkedTransactions", { params })
    .then((res) => res.data);

export const cancelDeliveryTransaction = (
  transactionNumber: string,
  reason: string
): Promise<void> =>
  axios
    .delete("synchronization", {
      params: { transactionCode: transactionNumber, reason },
      // be-transaction-synchronization-service reuses error codes 1100+ that
      // collide with be-transaction-service's own enum, so the shared
      // transactions error dictionary resolves them to an unrelated message.
      // The toast is produced locally in TransactionDetails instead, and the
      // dictionary is bypassed so Sentry reports the server's own message.
      hideToast: true,
      skipSharedErrorDictionary: true,
    })
    .then((res) => res.data);
